import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography, useMediaQuery, useTheme } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import { useFormDialogMainController } from "./controller/form";
import { SuppliesMainGroupName } from "../../models/suppliesMain";
import ConfirmDialog from "../../components/ConfirmDialog";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { useTranslation } from "react-i18next";
import ErrorMessageComponent from "../../components/errorMessage";

interface Props {
    onClose: VoidFunction;
    onRefetchData: VoidFunction;
    selectedMain: SuppliesMainGroupName;
    dataMasterMainGroup: SuppliesMainGroupName[];
    merchant: {
        id: string,
        label: string
    },
}

export const MainCategoryForm = ({ onClose, onRefetchData, selectedMain, dataMasterMainGroup, merchant }: Props) => {
    const controller = useFormDialogMainController({ merchantId: merchant?.id, selectedMain, onRefetchData, onClose, dataMasterMainGroup });
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { i18n } = useTranslation("global");

    return (
        <form onSubmit={controller.handleOpenForm}>
            <Box sx={{ p: isSmallScreen ? 2 : 6 }}>
                <Box mb={isSmallScreen ? 1 : 2}>
                    <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
                        {selectedMain ? "Edit" : "Add"} Main group
                    </Typography>
                </Box>
                <Box
                    sx={{
                        p: isSmallScreen ? 2 : 4,
                        boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    }}
                >
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="main-group-label-id" shrink={true}>Main Group</InputLabel>
                        <Select
                            labelId="main-group-label-id"
                            id="main-group-id"
                            value={controller.masterMainGroup}
                            label="Main Group"
                            onChange={controller.handleMasterMainGroupChange}
                            sx={{
                                maxWidth: 250
                            }}
                        >
                            {
                                dataMasterMainGroup?.map((item: any) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.main_group_name_en : item?.main_group_name_la}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </Box>
                <ErrorMessageComponent errorMessage={controller.errorMessage} />
                <Box mt={isSmallScreen ? 4 : 2} sx={{ display: 'flex', justifyContent: isSmallScreen ? 'center' : 'end' }}>
                    <Button
                        variant='outlined'
                        color="error"
                        sx={{ textTransform: 'none', mr: isSmallScreen ? 1 : 2, width: 100 }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        color="secondary"
                        sx={{ textTransform: 'none', color: '#fff', width: 150 }}
                    >
                        {selectedMain ? "Edit Category" : "Add Category"}
                    </Button>
                </Box>
            </Box>
            <ConfirmDialog
                open={controller.openConfirm}
                title={`Do you want to ${selectedMain ? "Update" : "Create"}`}
                loading={controller.loadingConfirmButton}
                onCancel={controller.handleCloseConfirm}
                onConfirm={controller.handleSubmit}
            />
        </form>
    )
}
